// extracted by mini-css-extract-plugin
export var mySwiper = "carousel-module--mySwiper--XDELn";
export var swiperSlide = "carousel-module--swiperSlide--CBDYX";